import { useQuery } from '@tanstack/react-query';
import { useDebounce } from '@/hooks/useDebounce';
import { getCustomerRequest, listCustomerRequests, searchCustomerRequests } from '../api';
import type { CustomerRequestStatus } from '../types';

export const customerRequestKeys = {
  all: ['customer-requests'] as const,
  list: (status: CustomerRequestStatus | 'all') => [...customerRequestKeys.all, 'list', status] as const,
  detail: (id: string) => [...customerRequestKeys.all, 'detail', id] as const,
  search: (q: string) => [...customerRequestKeys.all, 'search', q] as const,
};

export function useCustomerRequests(status: CustomerRequestStatus | 'all') {
  return useQuery({
    queryKey: customerRequestKeys.list(status),
    queryFn: () => listCustomerRequests(status),
  });
}

export function useCustomerRequest(id: string | null) {
  return useQuery({
    queryKey: customerRequestKeys.detail(id ?? ''),
    queryFn: () => getCustomerRequest(id as string),
    enabled: !!id,
  });
}

/** Duplicate check while an AM types a new title. */
export function useCustomerRequestSearch(text: string) {
  const q = useDebounce(text.trim(), 300);
  return useQuery({
    queryKey: customerRequestKeys.search(q),
    queryFn: () => searchCustomerRequests(q),
    enabled: q.length >= 2,
  });
}
